import React from 'react';
import styled from 'styled-components';
import { tc } from 'utils/theme';
import theme from 'themes/global';

const BACKGROUND_COLOR = 'fontHighlighted';
const FONT_HIGHLIGHTED_COLOR = theme.colors[BACKGROUND_COLOR];

export const h2BaseStyle = `
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 24px;
  letter-spacing: -0.00833em;
  line-height: 32px;
  margin: 15px 0;
`;

export const h2WithBackgroundStyle = `
  ${h2BaseStyle}
  background: ${FONT_HIGHLIGHTED_COLOR};
  padding: 10px 15px;
`;

const StyledH2 = styled.h2`
  ${h2BaseStyle}
  background: ${(p) => (p.background ? tc(BACKGROUND_COLOR)(p) : 'none')};
  padding: ${(p) => (p.background ? '10px 15px' : '0')};
  text-align: ${(p) => (p.center ? 'center' : 'left')};
`;

const H2 = (props) => <StyledH2 {...props} />;

export default H2;
